module.exports = __webpack_public_path__ + "static/media/menu-card-2.bd2258d9.jpg";